import { useEffect } from 'react';

import styled from '@emotion/styled';

const PaymentSuccessful = () => {
  useEffect(() => {
    setTimeout(() => window.parent.postMessage('paymentCompleted', '*'), 1500);
  }, []);

  return (
    <Container>
      <div>🎉</div>
    </Container>
  );
};

export default PaymentSuccessful;

const Container = styled.div`
  display: grid;
  place-items: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  justify-content: center;
  /* border: 1px solid red; */

  font-size: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.redFontColor};
  background: rgba(142, 125, 125, 0);

  & > div {
    /* border: 4px solid ${({ theme }) => theme.palette.redFontColor}; */
    padding: 50px;
    text-align: center;
    animation: translate-animation 1s ease-in-out both;

    @keyframes translate-animation {
      from {
        transform: translateY(0px) scale(100%);
        opacity: 1;
      }
      90% {
        opacity: 0.2;
      }
      to {
        transform: translateY(-300px) scale(200%);
        opacity: 0;
      }
    }
  }
`;
